package net.frozenbit.games.soundgame.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.painter.BitmapPainter
import androidx.compose.ui.graphics.toArgb
import androidx.compose.ui.graphics.toComposeImageBitmap
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import net.frozenbit.games.soundgame.components.JoinCode
import net.frozenbit.games.soundgame.components.PlayerTag
import net.frozenbit.games.soundgame.theme.onSecondaryContainerLight
import net.frozenbit.games.soundgame.theme.secondaryContainerLight
import net.frozenbit.games.soundgame.utils.pngBytes
import net.frozenbit.games.soundgame.viewmodels.presentation.PlayerTagData
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.skia.Image
import qrcode.QRCode
import soundgame.app.shared.generated.resources.Res
import soundgame.app.shared.generated.resources.placeholder_qr

@Composable
fun HostLobbyScreen(
    joinCode: String,
    players: List<PlayerTagData>,
    link: String,
) {
    val qrImageState = remember { mutableStateOf<ImageBitmap?>(null) }
    LaunchedEffect(link) {
        qrImageState.value = renderQrCode(link)
    }
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(16.dp),
        ) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                Text(
                    "frozenbit.net/s",
                    fontSize = 36.sp,
                    style = TextStyle(
                        color = Color.Blue,
                        textDecoration = TextDecoration.Underline,
                    ),
                )
                JoinCode(joinCode)
            }
            val qrImage = qrImageState.value
            androidx.compose.foundation.Image(
                painter = qrImage?.let {
                    remember(qrImage) { BitmapPainter(qrImage) }
                } ?: painterResource(Res.drawable.placeholder_qr),
                contentDescription = "QR Code",
                modifier = Modifier
                    .background(
                        onSecondaryContainerLight,
                        RoundedCornerShape(16.dp),
                    )
                    .padding(16.dp)
                    .size(200.dp)
                    .align(Alignment.CenterHorizontally)
            )
            Row(
                horizontalArrangement = Arrangement.spacedBy(8.dp),
            ) {
                players.forEach { player ->
                    PlayerTag(
                        name = player.name,
                        avatarIndex = player.avatarIndex,
                        offline = player.isOffline,
                    )
                }
            }
        }
    }
}

internal suspend fun renderQrCode(link: String): ImageBitmap? {
    val qrBlob = QRCode
        .ofSquares()
        .withColor(secondaryContainerLight.toArgb())
        // improve density by using alphanumeric encoding (needs uppercase)
        .build(link.uppercase())
        .render()
        .pngBytes()
    if (qrBlob == null) {
        println("Failed to generate QR code")
        return null
    }
    return Image.makeFromEncoded(qrBlob).toComposeImageBitmap()
}
